<template>
  <el-dialog :visible.sync="showDetailDialog" v-if="showDetailDialog"  @close='onClose'  :title="dialogTitle" width="55%">
    <div style="width: 100%; height: 100%" class="operator_dialog">
      <el-row class="inform_title">
        <span class="title_name">基础信息</span>
        <span style="float: right; padding-right: 40px">
          <img
           v-if="spaceDetail.officialStatus==2"
            :src="gstbImg"
            alt=""
            style="width: 40px; height: 40px; vertical-align: middle"
        /></span>
      </el-row>
      <el-row :gutter="20" class="info-detail">
        <el-col :span="12">
          <div class="info-detail-block">
            <span>主体类型：</span
            ><span>{{ spaceDetail.enterpriseTypeName }}</span>
          </div>
          <div class="info-detail-block">
            <span>经营类型：</span
            ><span>{{ spaceDetail.industryDicName }}</span>
          </div>
          <div class="info-detail-block">
            <span>证件号码：</span
            ><span>{{ spaceDetail.unifiedSocialCreditCode }}</span>
          </div>
          <div class="info-detail-block">
            <span>主体位置：</span><span>{{ spaceDetail.qhmc }}</span
            ><img
              @click="openMap"
              src="../../../../static/img/location.svg"
              class="location-svg"
              alt=""
            />
          </div>
          <div class="info-detail-block">
            <span>注册地址：</span><span>{{ spaceDetail.address }}</span>
          </div>
          <div class="info-detail-block">
            <span>注册资金：</span
            ><span>{{ spaceDetail.registerCapital }}万元</span>
          </div>
          <div class="info-detail-block">
            <span>成立日期：</span
            ><span>{{ formatterDate(spaceDetail.createDate)}}</span>
          </div>
          <div class="info-detail-block">
            <span>联系人姓名：</span
            ><span>{{ spaceDetail.contacts }}</span>
          </div>
          <div class="info-detail-block">
            <span>联系人手机号：</span
            ><span>{{spaceDetail.mobile }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-detail-block">
            <span>主体等级：</span
            ><span>{{ spaceDetail.gradeName }}</span>
          </div>

          <div class="info-detail-block">
            <span style="width: 369px;">证件照片：</span>
            <div>
              <span v-if="qualificationImg.length!=0">
                <el-image
                v-for="(item,index) in qualificationImg" :key="index"
                class="info-detail-block-license"
                :src="item.url"
                alt=""
                :preview-src-list="[item.url]"
              >
              </el-image>
              </span>
              <span v-else>暂无图片</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="inform_title">
        <span class="title_name">人员信息</span>
      </el-row>
      <el-row :gutter="20" class="info-detail">
        <el-col :span="12">
          <div class="info-detail-block">
            <span>法人姓名：</span><span>{{ spaceDetail.corporationName }}</span>
          </div>
          <div class="info-detail-block">
            <span>法人证件号码：</span><span>{{ spaceDetail.corporationCardId }}</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-detail-block">
            <span>法人手机号：</span><span>{{ spaceDetail.corporationMobile }}</span>
          </div>
          <!-- <div class="info-detail-block">
            <span>法人身份：</span><span>{{spaceDetail.qhmc}}</span>
          </div> -->
        </el-col>
      </el-row>
      <div class="info-detail-block" style="padding-left: 10px; display: flex">
        <span>法人证件照片：</span>
        <div class="info-detail-block-img">
          <el-image
            style="width: 100%"
            :src="
              spaceDetail.corporationCardFrontUrl
                ? spaceDetail.corporationCardFrontUrl
                : ''
            "
            :preview-src-list="[spaceDetail.corporationCardFrontUrl]"
            v-if="
              spaceDetail.corporationCardFrontUrl &&
              spaceDetail.corporationCardFrontUrl
            "
          >
          </el-image>
          <span v-else>暂无图片</span>
        </div>
        <div class="info-detail-block-img">
          <el-image
            style="width: 100%; height: 100%"
            :src="
              spaceDetail.corporationCardBackUrl
                ? spaceDetail.corporationCardBackUrl
                : ''
            "
            v-if="
              spaceDetail.corporationCardBackUrl &&
              spaceDetail.corporationCardBackUrl
            "
            :preview-src-list="[spaceDetail.corporationCardBackUrl]"
          >
          </el-image>
          <span v-else>暂无图片</span>
        </div>
      </div>
      <el-row class="inform_title">
        <span class="title_name">其他信息</span>
      </el-row>
      <el-row :gutter="20" class="info-detail">
        <el-col :span="12">
          <div class="info-detail-block">
            <span>是否加入联合社：</span
            ><span>{{
              spaceDetail.isUnionOrganization === 1 ? "是" : "否"
            }}</span>
          </div>
          <div class="info-detail-block">
            <span>开户账号：</span><span>{{ spaceDetail.bankNumber }}</span>
          </div>
          <div class="info-detail-block">
            <span>开户许可证： </span>
            <el-image
              class="info-detail-block-license"
              :src="licenseImg"
              alt=""
              v-if="licenseImg"
              :preview-src-list="[licenseImg]"
            >
            </el-image>
            <span v-else>暂无图片</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="info-detail-block">
            <span>开户银行：</span><span>{{ spaceDetail.bankName }}</span>
          </div>
          <div class="info-detail-block" style="justify-content: flex-start;">
            <span style="width: 82px;;">主体简介：</span><span style="width: 100%;">{{ spaceDetail.description }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row class="inform_title">
        <span class="title_name">审核日志</span>
      </el-row>
      <el-row style="padding-bottom: 20px">
        <div class="record" v-for="(item,index) in listLog" :key="index">
          <div class="record_box">
             <div style="color: red;padding-right: 12px;" v-if="item.checkStatus==2"><i class="el-icon-circle-close"></i></div>
              <div style="color: #0abe77;padding-right: 12px;"  v-else>
              <i class="el-icon-success" ></i>
            </div>
            <div>{{GLOBAL.timetoDate(item.creatTime)}} || {{item.content}}:
              <span v-if="item.checkStatus==1">通过</span>
              <span v-if="item.checkStatus==3">成功</span>
              <span v-if="item.checkStatus==2">驳回</span>
              ||<span v-if="item.checkStatus==2">{{item.checkStatusDescription}}原因:{{item.remark}}||</span>  操作人:{{item.operator}}</div>
          </div>
        </div>
      </el-row>

      <el-row v-if="ifRejected" class="detail_item" :gutter="20">
        <div class="detail_name">
          驳回意见：<span>{{ spaceDetail.refuseReason }}</span>
        </div>
      </el-row>
      <!-- <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center"
        v-if="ifAbnormal"
      >
        <el-button size="small" type="primary" @click="abnormal"
          >加入异常</el-button
        >
        <el-button size="small" type="primary" @click="cancellation"
          >加入注销</el-button
        >
      </div> -->
        <!-- v-if="ifAudit" -->
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center"
        v-if="showDisableds"
      >
       <div >
          <el-button size="small" type="primary" @click="throughAudit"
            >通 过</el-button
          >
          <el-button size="small" type="primary" @click="rejectAuditHandler"
            >不 通 过</el-button
          >
       </div>
      </div>
      <!-- 不通过 -->
      <el-dialog
        title="驳回原因"
        @close="ifShowReject = false"
        :visible.sync="ifShowReject"
        v-if="ifShowReject"
        width="30%"
        append-to-body
        style="text-align: center"
        center
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="驳回原因"
            prop="refusedReason"
            class="ruleForm-input"
            :rules="{
              required: true,
              message: '驳回原因',
              trigger: 'blur',
            }"
          >
            <el-input
              style="
                width: 70%;
                border: none;
                background: #e5e8efff;
                color: #d5d8e0ff;
              "
              v-model="ruleForm.refusedReason"
              placeholder="请输入驳回原因"
              type="textarea"
              show-word-limit
              maxlength="100"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button size="small" type="primary" @click="ifShowReject = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="confirmReject"
            >确定</el-button
          >
        </div>
      </el-dialog>
      <!-- 通过 -->
      <el-dialog
        title="通过等级"
        @close="ifShowthrough = false"
        :visible.sync="ifShowthrough"
        v-if="ifShowthrough"
        width="30%"
        append-to-body
        style="text-align: center"
        center
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="110px"
          class="demo-ruleForm"
        >
          <el-form-item label="申报级别" class="ruleForm-input">
            <el-input
              style="width: 70%"
              v-model="spaceDetail.gradeName"
              disabled
              placeholder="请输入申报等级"
            ></el-input>
          </el-form-item>
          <el-form-item label="主体实际等级" class="ruleForm-input">
            <el-select
              v-model="ruleForm.gradeCode"
              placeholder="请选择主体等级"
              style="width: 70%"
              @change="gradeCodeChange"
            >
              <el-option
                v-for="item in listOptions"
                :key="item.dicNumber"
                :label="item.dicName"
                :value="item.dicNumber"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="评选年度"
            prop="year"
            :rules="{
              required: true,
              type: 'year',
              message: '评选年度为空',
              trigger: 'change',
            }"
            class="ruleForm-input"
          >
            <el-date-picker
               style="width: 70%"
               v-model="ruleForm.year"
               type="year"
              :default-value="selectMaxYear"
              :picker-options="{ disabledDate: selectYear }"
              placeholder="选择年"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer" style="text-align: center">
          <el-button size="small" type="" @click="ifShowthrough = false"
            >取消</el-button
          >
          <el-button size="small" type="primary" @click="enterpriseCheck"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <mapLog ref="mapLog"></mapLog>
  </el-dialog>
</template>
<script>
import API from "@/api/serviceOrgManagement/api_userManagement";
import Cookies from "js-cookie";
import mapLog from "./mapLog.vue";
import mapboxgl from "mapbox-gl";
import gstbImg from "../../../../static/img/gstb.png";
export default {
  name: "operatorDialog",
  components: { mapLog: mapLog },
  props: ["ifAudit", "ifRejected", "ifAbnormal"],
  data() {
    return {
      gstbImg: gstbImg,
      selectMaxYear: null,

      ruleForm: {
        refusedReason: "",
        gradeName: "",
        gradeCode:"",
        year: "2022", //当前年
        status:null,//审核状态
      },
      rules: {
        refusedReason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      },
      spaceDetail: {}, //页面详情
      ifShowReject: false,
      ifShowthrough: false,
      showDetailDialog: false,
      number: "",
      qualificationImg: [], //主体资格证明图片
      licenseImg: "", //许可证图片
      dialogTitle: "主体名称",
      listOptions: [],
      dicNumber: "",
      params:{},
      listLog:[],
      showDisableds:false,
    };
  },
  methods: {
    selectYear(date) {
      let year = new Date(date).getFullYear();
      let currentYear = new Date().getFullYear();
      if (currentYear - year < -0 || currentYear - year > 15) {
        return true;
      } else {
        return false;
      }
    },
    formatterDate(cellValue) {
      if (!cellValue) {
        return "--";
      }
      return this.GLOBAL.timetoDate(Number(cellValue), "date");
    },
    filterUrl(list) {
      let imgList = [];
      if (list && list.length) {
        list.forEach((item) => {
          if (item && item.url) {
            imgList.push(item.url);
          }
        });
        return imgList;
      } else {
        return [];
      }
    },
    // 打开地图定位
    openMap() {
      if (!this.spaceDetail.lgd) return this.GLOBAL.error("无当前主体定位");
      let lnglat = [this.spaceDetail.lgd, this.spaceDetail.ltd];
      // let lnglat = [110.934521014286, 31.8761197179647];
      this.$refs.mapLog.dialogOpen(lnglat);
    },

    // 打开详情弹窗
    dialogOpen(row) {
      this.spaceDetail = {};
      this.showDetailDialog = true;
      this.number = row.enterpriseNumber;
      this.dialogTitle = row.enterpriseName
        ? "主体名称：" + row.enterpriseName
        : "";
      console.log("row",row)
      this.licenseImg = ''
      let roleCode=Cookies.get('roleCode')
      if((row.status===4 && roleCode==='21' )||(row.status === 8 && roleCode ==='19')){
        this.showDisableds=true
      }else{
        this.showDisableds=false
      }
      this.priseDetail(row.enterpriseNumber);
      this.getcommonList();
    },
    // 查询当前打开项
    async priseDetail(number) {
      const { code, data, msg } = await API.priseDetail({ number });
      if (code === 0) {
          this.spaceDetail = data.UnauditedList;
          this.qualificationImg=[]
        this.spaceDetail.enterpriseImgList.forEach((item) => {
          if (item.type === 1) {
            this.qualificationImg.push(item)
          } else if (item.type === 4) {
            this.licenseImg = item.url;
          }else if(item.type === 11){
             this.qualificationImg.push(item);
          }
        });
        console.log("qualificationImg",this.qualificationImg)
         this.enterpriseLogList()
        //  let headurl=this.spaceDetail.corporationCardFrontUrl.substr(0,4)
        //  let headurlBack=this.spaceDetail.corporationCardBackUrl.substr(0,4)
            if(data.UnauditedList.corporationCardFrontUrl){
              this.spaceDetail.corporationCardFrontUrl='http://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/'+data.UnauditedList.corporationCardFrontUrl
            }
            if(data.UnauditedList.corporationCardFrontUrl){

               this.spaceDetail.corporationCardBackUrl='http://ram-garo-socia-prod.oss-cn-zhangjiakou.aliyuncs.com/'+data.UnauditedList.corporationCardBackUrl
            }
      } else {
        this.GLOBAL.error(msg);
      }
    },
    //日志
   async enterpriseLogList(){
      const {code,msg,data} =await API.enterpriseLogList({enterpriseNumber:this.number})
      this.listLog=data.list
    },
    // 选择事件
    gradeCodeChange(val){
     this.ruleForm.gradeCode=val
      this.listOptions.filter(item=>{
        if(item.dicNumber ==val){
          this.ruleForm.gradeName=item.dicName
        }
      })

    },
    // 通过审核
    throughAudit() {
      this.ifShowthrough = true;
      if(this.spaceDetail.status==4){
         this.ruleForm.status=1
         this.ruleForm.gradeCode=this.spaceDetail.gradeCode
         this.ruleForm.gradeName=this.spaceDetail.gradeName
         this.ruleForm.year='2022'
      }else if(this.spaceDetail.status==8){
         this.ruleForm.status=2
         this.ruleForm.gradeCode=this.spaceDetail.gradeCode
         this.ruleForm.gradeName=this.spaceDetail.gradeName
          this.ruleForm.year=this.spaceDetail.year.toString()

      }
      this.getParams();
    },
    //不通过
    rejectAuditHandler(){
      this.ifShowReject = true;
       if(this.spaceDetail.status==5){
        this.ruleForm.status=3
      }else{
         this.ruleForm.status=3
      }
      this.ruleForm.gradeCode=this.spaceDetail.gradeCode
      this.ruleForm.gradeName=this.spaceDetail.gradeName
      this.ruleForm.year=this.spaceDetail.year
      this.getParams();
    },


    // 参数
    getParams() {
      this.params = {
        number: this.number,
        gradeCode: this.ruleForm.gradeCode,
        gradeName: this.ruleForm.gradeName,
        status: this.ruleForm.status,
        refusedReason: this.ruleForm.refusedReason,
        year: new Date(this.ruleForm.year).getFullYear(),
      };
    },

    //通过按钮
    async enterpriseCheck() {
     if(this.ruleForm.year==0||this.ruleForm.year==''){
       this.$message({
          message: '评级年份不能为空',
          type: 'warning'
        });
     }
       this.getParams();
      const { code, msg, data } = await API.enterpriseCheck(this.params);
      if (code == 0) {
        this.$message({
          message: msg,
          type: 'success'
        });
        this.showDetailDialog = false;
        this.ifShowthrough = false
        this.$emit("tableRefresh");
        this.ruleForm.refusedReason=""
       }else{
          this.$message({
            message: msg,
            type: 'warning'
          });
       }
    },
    // 驳回按钮
   async confirmReject(){
      if(this.ruleForm.refusedReason==''){
          this.$message({
            message: '驳回原因不能为空',
            type: 'warning'
          });
          return
      }
       this.getParams();
      const { code, msg, data } = await API.enterpriseCheck(this.params);
      if (code == 0) {
        this.$message({
          message: msg,
          type: 'success'
        });
        this.showDetailDialog = false;
        this.ifShowReject = false
        this.ruleForm.refusedReason=""
        this.$emit("tableRefresh");
       }else{
        this.$message({
            message: msg,
            type: 'warning'
          });
       }
    },

    //主体等级
    async getcommonList() {
      let { code, msg, data } = await API.commonList({ code: 19 });
      if (code === 0) {
        if (data && data.list && data.list.length) {
          this.listOptions = data.list;
        }
      }
    },

    //加入异常
    abnormal() {
      this.$confirm("确定将该主体加入 异常主体, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code, data, msg } = await API.njbenterpriseUpdate({
            status: 6,
            number: this.number,
          });
          if (code === 0) {
            this.$message({
              message: msg,
              type: "success",
            });
            this.showDetailDialog = false;
            this.$emit("tableRefresh");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 注销
    cancellation() {
      this.$confirm("确定将该主体加入 注销主体 , 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { code, data, msg } = await API.njbenterpriseUpdate({
            status: 7,
            number: this.number,
          });
          if (code === 0) {
            this.$message({
              message: msg,
              type: "success",
            });
            this.showDetailDialog = false;
            this.$emit("tableRefresh");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onClose(){
      this.licenseImg = '';
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="less">
.pinkrow {
  width: 100%;
  // background-color: #FDEDE3;
  margin-bottom: 10px;
  padding-left: 10px;
}
.operator_dialog {
  .textInput {
    width: 50%;
  }
  .basic_info {
    &:extend(.pinkrow);
    height: 40px;
    line-height: 40px;
    padding-right: 10px;
    background: #f4f4f4;
    color: grey;
  }
  .detail_item {
    padding-left: 20px;
  }
}
.info-detail {
  padding-left: 10px;
  .info-detail-block {
    padding-bottom: 15px;
    display: flex;
    .location-svg {
      height: 18px;
      width: 12px;
      margin-left: 10px;
      cursor: pointer;
    }
    .info-detail-block-license {
      width: 200px;
      margin-top: 5px;
      // height: 197px;
    }
    .info-detail-block-openImg {
      width: 200px;
      // width: 138px;
    }
  }
}
.info-detail-block-img {
  width: 247px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ruleForm-input {
  .el-form-item__content {
    margin: 0 !important;
  }
}
.record {
  // height: 30px;
  width: 98%;
  margin-top: 5px;
  line-height: 30px;
  border: 0.5px solid seagreen;
}
.record_box {
  display: flex;
  // justify-content: space-between;
  padding-right: 30px;
  padding-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/studio/subject/libraryListReviewed/detailDialog.vue